import React, { ReactNode }                       from 'react';
import { EPhotoType }                             from '@enums/auction';
import PassengerSideFrontQuarterBeautyShotGraphic from '../assets/Passenger_Side_Front_Quarter_Beauty_Shot_Graphic.svg';
import FrontDistantGraphic                        from '../assets/Front_Distant_Graphic.svg';
import DriverSideFrontQuarterGraphic              from '../assets/Driver_Side_Front_Quarter_Graphic.svg';
import DriverSideGraphic                          from '../assets/Driver_Side_Graphic.svg';
import DriverSideRearQuarterGraphic               from '../assets/Driver_Side_Rear_Quarter_Graphic.svg';
import RearDistantGraphic                         from '../assets/Rear_Distant_Graphic.svg';
import PassengerSideRearQuarterGraphic            from '../assets/Passenger_Side_Rear_Quarter_Graphic.svg';
import PassengerSideGraphic                       from '../assets/Passenger_Side_Graphic.svg';
import TireCloseUpGraphic                         from '../assets/Tire_CloseUp_Graphic.svg';
import InteriorGraphic                            from '../assets/Interior_Graphic.svg';
import OdometerGraphic                            from '../assets/Odometer_Graphic.svg';
import EngineCloseUpGraphic                       from '../assets/Engine_CloseUp_Graphic.svg';

export const PHOTO_PLACEHOLDER: Record<EPhotoType, ReactNode> = {
  [EPhotoType.PassengerSideFrontQuarter] : <PassengerSideFrontQuarterBeautyShotGraphic />,
  [EPhotoType.FrontDistant]              : <FrontDistantGraphic />,
  [EPhotoType.DriverSideFrontQuarter]    : <DriverSideFrontQuarterGraphic />,
  [EPhotoType.DriverSide]                : <DriverSideGraphic />,
  [EPhotoType.DriverSideRearQuarter]     : <DriverSideRearQuarterGraphic />,
  [EPhotoType.RearDistant]               : <RearDistantGraphic />,
  [EPhotoType.PassengerSideRearQuarter]  : <PassengerSideRearQuarterGraphic />,
  [EPhotoType.PassengerSide]             : <PassengerSideGraphic />,
  [EPhotoType.TireCloseup]               : <TireCloseUpGraphic />,
  [EPhotoType.Interior]                  : <InteriorGraphic />,
  [EPhotoType.Odometer]                  : <OdometerGraphic />,
  [EPhotoType.EngineCloseup]             : <EngineCloseUpGraphic />,
  [EPhotoType.Other]                     : <></>,
};

export const PHOTO_NAME: Record<EPhotoType, string> = {
  [EPhotoType.PassengerSideFrontQuarter] : 'Passenger Side Front Quarter / Beauty Shot',
  [EPhotoType.FrontDistant]              : 'Front Distant',
  [EPhotoType.DriverSideFrontQuarter]    : 'Driver Side Front Quarter',
  [EPhotoType.DriverSide]                : 'Driver Side',
  [EPhotoType.DriverSideRearQuarter]     : 'Driver Side Rear Quarter',
  [EPhotoType.RearDistant]               : 'Rear Distant',
  [EPhotoType.PassengerSideRearQuarter]  : 'Passenger Side Rear Quarter',
  [EPhotoType.PassengerSide]             : 'Passenger Side',
  [EPhotoType.TireCloseup]               : 'Tire Close-up',
  [EPhotoType.Interior]                  : 'Interior',
  [EPhotoType.Odometer]                  : 'Odometer',
  [EPhotoType.EngineCloseup]             : 'Engine Close-up',
  [EPhotoType.Other]                     : 'Additional Image',
};
